module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__contact-dealer--section"
  }, [_c('div', {
    staticClass: "system-builder__main-container"
  }, [_c('div', {
    staticClass: "system-builder__contact-dealer--main-container"
  }, [_c('div', {
    staticClass: "system-builder__contact-dealer--dealers-container"
  }, [_c('div', {
    staticClass: "system-builder__main-container--header"
  }, [_c('h2', [_vm._v("Get a Quote from Your Local Dealer!")]), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.editContactForm
    }
  }, [_vm._v("Edit Contact Info")])]), _vm._v(" "), (_vm.sharedState.dealers === null) ? _c('div', {
    staticClass: "system-builder__contact-dealer--dealers-container-alt"
  }, [_c('spinner', {
    attrs: {
      "size": "large",
      "message": "Loading dealers nearby..."
    }
  })], 1) : _c('div', {
    staticClass: "system-builder__contact-dealer--dealer-items-container"
  }, _vm._l((_vm.sharedState.dealers), function(dealer, index) {
    return _c('div', {
      key: dealer.ID,
      staticClass: "system-builder__contact-dealer--dealer-item"
    }, [_c('div', {
      staticClass: "system-builder__contact-dealer--dealer-content"
    }, [_c('div', {
      staticClass: "dealer-details"
    }, [_c('h5', [_vm._v(_vm._s(dealer.post_title))]), _vm._v(" "), _c('p', [_vm._v("\n                  " + _vm._s(dealer.custom_fields.wpsl_address[0])), _c('br'), _vm._v("\n                  " + _vm._s(dealer.custom_fields.wpsl_city[0]) + ", " + _vm._s(dealer.custom_fields.wpsl_state[0]) + " " + _vm._s(dealer.custom_fields.wpsl_zip[0]) + "\n                ")])]), _vm._v(" "), (dealer.custom_fields.tx_wpsl_store_category[0] === 'PRO') ? _c('div', {
      staticClass: "pro-logo"
    }, [_c('img', {
      attrs: {
        "src": "",
        "alt": ""
      }
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "system-builder__contact-dealer--dealer-cta-container"
    }, [_c('div', {
      staticClass: "button__outline--primary"
    }, [_c('a', {
      attrs: {
        "href": _vm.prepareTelLink(dealer.custom_fields.wpsl_phone[0])
      }
    }, [_vm._v("Call")])]), _vm._v(" "), (dealer.custom_fields.wpsl_email[0]) ? _c('div', {
      staticClass: "button__solid--blue"
    }, [_vm._v("Get E-Quote")]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: " system-builder__contact-dealer--system-container"
  }, [_c('div', {
    staticClass: "system-builder__main-container--content"
  }, [_c('div', {
    staticClass: "system-builder__view-system--main-container"
  }, [_c('div', {
    staticClass: "system-builder__view-system--system-container"
  }, [_vm._m(0), _vm._v(" "), (_vm.sharedState.selectedSystem) ? _c('div', {
    staticClass: "system-builder__view-system--system-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.sharedState.selectedSystem.images[0].image.url,
      "alt": _vm.sharedState.selectedSystem.images[0].image.alt
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--system-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.sharedState.systemString))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(_vm._s(_vm.sharedState.selectedSystem.subtitle))])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.sharedState.selectedSystem.description)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--addon-container"
  }, [_c('div', {
    staticClass: "system-builder__view-system--remote-container"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "system-builder__remotes--item"
  }, [_c('div', {
    staticClass: "system-builder__remotes--item-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.sharedState.selectedRemote.images[0].image.url,
      "alt": _vm.sharedState.selectedRemote.images[0].image.alt
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__remotes--item-content"
  }, [_c('h3', [_vm._v(_vm._s(_vm.sharedState.selectedRemote.post_title))]), _vm._v(" "), _c('ul', _vm._l((_vm.sharedState.selectedRemote.remote_features), function(feature, featureIndex) {
    return (featureIndex < 3) ? _c('li', [_vm._v(_vm._s(feature) + "\n                      ")]) : _vm._e()
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "system-builder__view-system--upgrades-container"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.sharedState.selectedUpgrades), function(upgrade) {
    return _c('div', {
      staticClass: "system-builder__upgrades--item"
    }, [_c('div', {
      staticClass: "system-builder__upgrades--item-image"
    }, [_c('img', {
      attrs: {
        "src": upgrade.images[0].image.url,
        "alt": upgrade.images[0].image.alt
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "system-builder__upgrades--item-content"
    }, [_c('h4', [_vm._v(_vm._s(upgrade.post_title))]), _vm._v(" "), _c('ul', _vm._l((upgrade.features), function(feature) {
      return (upgrade.features) ? _c('li', [_vm._v(_vm._s(feature))]) : _vm._e()
    }))])])
  })], 2)])])])])])]), _vm._v(" "), _c('footerNav')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__view-system--edit-nav"
  }, [_c('span', [_vm._v("Your System")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__view-system--edit-nav"
  }, [_c('span', [_vm._v("Your Remote")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "system-builder__view-system--edit-nav"
  }, [_c('span', [_vm._v("Your Upgrades")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0932c597","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/ContactDealer.vue
// module id = 414
// module chunks = 1